import { render, staticRenderFns } from "./GeneralView.vue?vue&type=template&id=415c7f20&lang=pug&"
import script from "./GeneralView.vue?vue&type=script&lang=ts&"
export * from "./GeneralView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports